// @ts-expect-error - HTML import handled by custom loader
import template from "./widget.html";
import css from "./widget.css";
import { openMenu } from "../menu/menu";
import translateWidget from "../menu/translateWidget";

import {
    pluginConfig
} from "@/globals/pluginConfig";

import {
    userSettings
} from "@/globals/userSettings";

import reset from "../menu/reset";

export let $widget: HTMLElement;

export function renderWidget() {
    $widget = document.createElement("div");
    $widget.classList.add("asw-container");
    $widget.innerHTML = `<style>${css}</style>${template}`;

    const $widgetInner: HTMLElement = $widget.querySelector(".asw-widget");
    Object.assign($widgetInner.style, getContainerStyle());

    const $btn: HTMLElement = $widget.querySelector(".asw-menu-btn");
    $btn?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        openMenu();
    });

    const $resetBtn: HTMLElement = $widget.querySelector(".asw-reset-btn");
    $resetBtn?.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        reset();
    });

    translateWidget();

    document.body.appendChild($widget);

    updateWidgetResetButton();

    return $widget;
}

export function updateWidgetResetButton() {
    const $resetBtn: HTMLElement = document.querySelector(".asw-container .asw-reset-btn");
    if (!$resetBtn) return;

    $resetBtn.style.display = hasActiveSettings() ? "flex" : "none";
}

function hasActiveSettings(): boolean {
    const states = userSettings?.states || {};
    return Object.entries(states).some(([key, value]) => {
        if (key === "fontSize") return (value as number) !== 1;
        return !!value;
    });
}

function getContainerStyle() {
    const {
        position = "bottom-left",
        offset = [20, 20]
    } = pluginConfig;

    const [offsetX = 20, offsetY = 25] = offset;

    const centerY = `calc(50% - 27.5px - ${offsetY}px)`;
    const centerX = `calc(50% - 27.5px - ${offsetX}px)`;

    switch (position) {
        case "bottom-right":
            return { bottom: `${offsetY}px`, right: `${offsetX}px`, left: "auto" };
        case "top-left":
            return { top: `${offsetY}px`, left: `${offsetX}px`, bottom: "auto" };
        case "top-right":
            return { top: `${offsetY}px`, right: `${offsetX}px`, left: "auto", bottom: "auto" };
        case "center-left":
            return { left: `${offsetX}px`, bottom: centerY };
        case "center-right":
            return { right: `${offsetX}px`, left: "auto", bottom: centerY };
        case "bottom-center":
            return { bottom: `${offsetY}px`, left: centerX };
        case "top-center":
            return { top: `${offsetY}px`, bottom: "auto", left: centerX };
        default: // "bottom-left"
            return { bottom: `${offsetY}px`, left: `${offsetX}px` };
    }
}
